import ActionConstants from "../action-constants";
import Action from "./Action";


class ApplyCouponActions extends Action {
  static hasApplied(data) {
    return {
      type: ActionConstants.CHECK_COUPON_DATA,
      payload: {
        data,
      },
    };
  }
}

export default ApplyCouponActions;
